import { ref } from "vue";
import { getCallId } from "./callState";
import { activeRoomState } from "./active_room";
import { ws_instance } from "../websocket/ws-instance";

const mode = {
  grid: 0,
  stream: 1,
  speaker: 2,
  one: 3,
} as const;

interface OutgoingFullScreenEvent {
  call_id: string;
  mode: number;
  open: boolean;
}

export const fullScreenModeState = ref(false);

export function requestFullScreenMode() {
  if (document.body.requestFullscreen) {
    document.body.requestFullscreen();
    //@ts-ignore
  } else if (document.body.webkitRequestFullscreen) {
    //@ts-ignore
    document.body.webkitRequestFullscreen();
  }
}

export function exitFullScreenMode() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
    //@ts-ignore
  } else if (document.webkitExitFullscreen) {
    //@ts-ignore
    document.webkitExitFullscreen();
  }
}

document.addEventListener("fullscreenchange", () => {
  if (document.fullscreenElement) {
    fullScreenModeState.value = true;
  } else {
    fullScreenModeState.value = false;
  }
  const event: OutgoingFullScreenEvent = {
    call_id: getCallId(),
    mode: mode[activeRoomState.mode],
    open: fullScreenModeState.value,
  };
  ws_instance.api_message("fullscreen-event", event);
});

document.addEventListener("webkitfullscreenchange", () => {
  if (document.fullscreenElement) {
    fullScreenModeState.value = true;
  } else {
    fullScreenModeState.value = false;
  }
  const event: OutgoingFullScreenEvent = {
    call_id: getCallId(),
    mode: mode[activeRoomState.mode],
    open: fullScreenModeState.value,
  };
  ws_instance.api_message("fullscreen-event", event);
});
